// extracted by mini-css-extract-plugin
export default {"cFooterWrapper":"Footer_cFooterWrapper__ILJHQ","cFooter":"Footer_cFooter__gLuHJ","logo":"Footer_logo__+JiYo"};